import { Component } from '@angular/core';
import { MAPSPartnerTokenUserEntity } from 'mj_generatedentities';
import { RegisterClass } from '@memberjunction/global';
import { BaseFormComponent } from '@memberjunction/ng-base-forms';

@RegisterClass(BaseFormComponent, 'Partner Token Users') // Tell MemberJunction about this class
@Component({
    standalone: false,
    selector: 'gen-mapspartnertokenuser-form',
    templateUrl: './mapspartnertokenuser.form.component.html'
})
export class MAPSPartnerTokenUserFormComponent extends BaseFormComponent {
    public record!: MAPSPartnerTokenUserEntity;

    override async ngOnInit() {
        await super.ngOnInit();
        this.initSections([
            { sectionKey: 'details', sectionName: 'Details', isExpanded: true }
        ]);
    }
}

